import { NgModule } from '@angular/core';
import { SharedModule } from 'src/app/shared/shared.module';
import { DetailBeneficiaireComponent } from './detail-beneficiaire/detail-beneficiaire.component';
import { BeneficiaireFormComponent } from './beneficiaire-form/beneficiaire-form.component';
import { ListBeneficiaireComponent } from './list-beneficiaire/list-beneficiaire.component';
import { GestionDonneesModule } from '../gestion-donnees/gestion-donnees.module';
import { BeneficiaireModalDetailFormationComponent } from './modal/beneficiaire-modal-detail-formation/beneficiaire-modal-detail-formation.component';
import { BeneficiaireModalAjoutFormComponent } from './modal/beneficiaire-modal-ajout-form/beneficiaire-modal-ajout-form.component';
import { SortByMissionDatePipe } from 'src/app/shared/pipes/order-by/sort-by-mission-date.pipe';

@NgModule({
	declarations: [
		DetailBeneficiaireComponent,
		BeneficiaireFormComponent,
		ListBeneficiaireComponent,
		BeneficiaireModalDetailFormationComponent,
		BeneficiaireModalAjoutFormComponent
	],
	imports: [SharedModule, GestionDonneesModule]
})
export class BeneficiairesModule {}
